import { render, staticRenderFns } from "./UserCompleteProfile.vue?vue&type=template&id=2cbcc022"
import script from "./UserCompleteProfile.vue?vue&type=script&lang=js"
export * from "./UserCompleteProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports